import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getEmailNotificationStatuses } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/emailNotificationStatuses";
const emailNotificationStatusesSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(emailNotificationStatusesThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(emailNotificationStatusesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(emailNotificationStatusesThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const emailNotificationStatusesThunk = createAsyncThunk(
  `${sliceName}/emailNotificationStatusesThunk`,
  async () => {
    const response = await getEmailNotificationStatuses()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.emailNotificationStatuses);
    },
  },
);

export default emailNotificationStatusesSlice.reducer;
